import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  position: absolute;
  z-index: 1;
  right: 56px;
  top: 640px;

  @media (min-width: 768px) {
    position: fixed;
    right: 156px;
    top: 460px;
  }
`

export const Tag = styled.div`
  width: 66px;
  box-shadow: 0px 0px 10px 0px rgba(117, 117, 117, 0.1);
  padding: 4px 8px;
  border-radius: ${theme.border.smallRadius};
  background-color: ${theme.colors.white};

  color: ${theme.colors.green1};
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
`

export const OutterCircle = styled.div`
  position: absolute;
  top: -12px;
  right: -40px;

  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: ${theme.colors.green2};

  display: flex;
  justify-content: center;
  align-items: center;
`
